<template>
    <div>
        <b-card no-body>
            <b-tabs pills card v-model="selectedRegionIndex">
                <b-tab lazy v-for="region in regions" :key="region.region_code"
                       :title="region.region_name">
                    <table class="table table-sm">
                        <thead>
                        <tr>
                            <th>Provincia</th>
                            <th>Prodotto</th>
                            <th>Garanzie</th>
                            <th>Regole sconti</th>
                            <th class="col-number">Provvigione nuovo (%)</th>
                            <th class="col-number">Provvigione rinnovo (%)</th>
                            <th class="col-number">Età min conducente</th>
                            <th class="col-number">Età max veicolo</th>
                            <th class="col-number">Sconto Bersani (%)</th>
                            <th class="col-number">Sconto RC Familiare (%)</th>
                            <th class="col-number">Sconto (%)</th>
                            <th class="col-number">Broker (%)</th>
                            <th class="col-actions"></th>
                        </tr>
                        </thead>
                        <template v-for="province in selectedProvinces">
                            <template v-if="localValue[province.belong_to] && localValue[province.belong_to].length>0">
                                <tr v-for="(provinceProduct,index) in localValue[province.belong_to]">
                                    <td v-if="index===0"
                                        :rowspan="localValue[province.belong_to].length+1">
                                        <b>{{ province.belong_to }}</b>

                                    </td>
                                    <td>
                                        <select-product
                                            :provinceProduct="provinceProduct"
                                            :province="province.belong_to"/>
                                    </td>
                                    <td>
                                        <select-warranty
                                            :provinceProduct="provinceProduct"
                                            :province="province.belong_to"
                                            :provinceProducts="localValue[province.belong_to]"/>

                                    </td>
                                    <td>
                                        <select-discount-rule :provinceProduct="provinceProduct"/>
                                    </td>
                                    <td>
                                        <b-form-input v-model="provinceProduct.provvigione"
                                                      type="number"
                                                      step="0.0001"
                                                      min="0"
                                                      max="100"
                                                      size="sm"/>
                                    </td>
                                    <td>
                                        <b-form-input v-model="provinceProduct.provvigione_rinnovo"
                                                      type="number"
                                                      step="0.0001"
                                                      min="0"
                                                      max="100"
                                                      size="sm"/>
                                    </td>
                                    <td>
                                        <b-form-input v-model="provinceProduct.eta_min_conducente"
                                                      type="number"
                                                      min="0"
                                                      max="100"
                                                      size="sm"/>
                                    </td>
                                    <td>
                                        <b-form-input v-model="provinceProduct.eta_max_veicolo"
                                                      type="number"
                                                      min="0"
                                                      max="100"
                                                      size="sm"/>
                                    </td>
                                    <td>
                                        <b-form-input v-model="provinceProduct.sconto_bersani"
                                                      type="number"
                                                      min="0"
                                                      step="0.0001"
                                                      max="100"
                                                      size="sm"/>
                                    </td>
                                    <td>
                                        <b-form-input v-model="provinceProduct.sconto_rc_familiare"
                                                      type="number"
                                                      min="0"
                                                      step="0.0001"
                                                      max="100"
                                                      size="sm"/>
                                    </td>
                                    <td>
                                        <b-form-input v-model="provinceProduct.sconto_max"
                                                      type="number"
                                                      min="0"
                                                      step="0.0001"
                                                      :max="getMaxDiscount(provinceProduct, province.belong_to)"
                                                      size="sm"/>
                                    </td>
                                    <td>
                                        <b-form-input v-model="provinceProduct.broker_margin"
                                                      type="number"
                                                      min="0"
                                                      step="0.0001"
                                                      max="100"
                                                      size="sm"/>
                                    </td>
                                    <td>
                                        <div>
                                            <b-button-toolbar aria-label="Actions">
                                                <btn-delete-product
                                                    :province_name="province.belong_to"
                                                    :index="index"
                                                    v-model="localValue"/>

                                                <btn-copy-product
                                                    :province_name="province.belong_to"
                                                    :index="index"
                                                    v-model="localValue"/>
                                            </b-button-toolbar>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="11">
                                        <b-button-toolbar aria-label="Actions">
                                            <btn-add-product
                                                v-model="localValue"
                                                :province_name="province.belong_to"/>
                                            <btn-copy-product
                                                v-model="localValue"
                                                :province_name="province.belong_to"/>
                                        </b-button-toolbar>
                                    </td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td>
                                        <b>{{ province.belong_to }}</b>
                                    </td>
                                    <td colspan="11">
                                        <b-button-toolbar aria-label="Actions">
                                            <btn-add-product v-model="localValue" :province_name="province.belong_to"/>
                                        </b-button-toolbar>
                                    </td>
                                </tr>
                            </template>
                        </template>
                    </table>
                </b-tab>
            </b-tabs>
        </b-card>
        <container-dialog></container-dialog>
    </div>
</template>

<script>


import SelectWarranty from "./SelectWarranty";
import store, {init} from "./store";
import SelectProduct from "./SelectProduct";
import SelectDiscountRule from "./SelectDiscountRule";
import cleanUpProducts from "./cleanUpProducts";
import BtnAddProduct from "./BtnAddProduct";
import BtnDeleteProduct from "./BtnDeleteProduct";
import BtnCopyProduct from "./BtnCopyProduct";

export default {
    name: 'ProvincesProducts',
    components: {BtnCopyProduct, BtnDeleteProduct, BtnAddProduct, SelectDiscountRule, SelectProduct, SelectWarranty},
    props: [
        'name',
        'value',
        'tariffs',
        'discountActivations',
        'provinces',
        'parentProfile',
    ],
    data() {
        return {
            selectedRegionIndex: 0,
            localValue: {},
            store: {}
        }
    },
    computed: {
        selectedRegion() {
            return store.regions[this.selectedRegionIndex]
        },
        selectedProvinces() {
            return this.provinces
                .filter(p => p.region_code === this.selectedRegion.region_code)
            //.sort((a, b) => a.belong_to.localeCompare(b.belong_to))
        },
        regions() {
            return store.regions
        }
    },
    watch: {
        localValue: {
            deep: true,
            handler() {
                this.$emit('change', cleanUpProducts(this.localValue))
            }
        }
    }
    ,
    created() {
        this.$set(this, 'localValue', this.value ?? {})
        init({
            tariffs: this.tariffs,
            discountActivations: this.discountActivations,
            provinces: this.provinces,
            parentProfile: this.parentProfile,
        })
    },
    methods: {
        getMaxDiscount(provinceProduct, province) {

            //filter by parent profile
            if (store.parentProfile) {
                const parentProvince = store.parentProfile.province_abilitate[province] ?? []
                const parentProduct = parentProvince
                    .find(i => i.tariffa_codice === provinceProduct.tariffa_codice
                        && i.warranty_codice === provinceProduct.warranty_codice)
                return parentProduct?.sconto_max ?? 0
            }

            return 100
        }
    }
}
</script>

<style scoped lang="scss">
.table-sm {
    //sm font
    font-size: .875rem;
}

.col-number {
    width: 65px;
}

.col-actions {
    width: 105px;
}
</style>
